import $ from "jquery";
import { Module } from "plugins/_application";
import { toggleClass, hasClass, removeClass, addClass } from "../utils/_class-handlers";
import { debounce } from '../utils/_debounce';
import NavigationScrollHandler from '../utils/_navigation-scroll';
import { animate, stagger } from 'animejs';

/*
 -------------------------------
 Class
 -------------------------------
 */

export default class Navigation extends Module {
	ready(app) {

		const MAIN_HEADER = document.querySelector('#main_header');
		const MAIN_NAV = document.querySelector('#main_nav');

		let scrollDistance = 80;
		if(hasClass(MAIN_HEADER, 'has-donation-bar')){
			scrollDistance = 40;
		}

		// Nav init
		if (MAIN_HEADER) {
			new ResponsiveNavigation('main_nav', 'navigation-toggle');
		}

		// Scroll handler
		new NavigationScrollHandler({
			scrollDistance: scrollDistance,
			headerElement: MAIN_HEADER,
			onEnter: () => {
				if (!hasClass(document.body, 'header-scrolled')) {
					addClass(document.body, 'header-scrolled');
				}
			},
			onExit: () => {
				if (hasClass(document.body, 'header-scrolled')) {
					removeClass(document.body, 'header-scrolled');
				}
			}
		});

		this.donationBarAnimation();
	}

	donationBarAnimation() {
		const BAR = document.querySelector('.donation-bar--add-animation');
		if (BAR) {
			setTimeout(() => {
				BAR.classList.add('donation-bar--animate');
			}, 500);
		}
	}
}

class ResponsiveNavigation {

	constructor(ID, TOGGLE_ID) {
		this.ID = ID;
		this.TOGGLE_ID = TOGGLE_ID;
		this.BREAKPOINT = 1160;
        this.canToggle = true;

		// Elements
		this.NAV = document.getElementById(ID);
		this.MAIN_HEADER = document.getElementById('main_header');
		this.NAV_OVERLAY = document.getElementById('overlay');
		this.NAV_TOGGLE = document.getElementById(TOGGLE_ID);
		this.SCROLL_LINKS = document.querySelectorAll('.scroll-link');
		this.BREAKER = document.getElementById('dark-nav-breaker');

		this.appendDropdownArrows();
		this.bindEventHandlers();

		// Testing
		// this.toggleNavigation();
    }

    bindEventHandlers() {

        /**
         * CLOSE MENU
         */

        this.NAV_OVERLAY.addEventListener('click', this.closeNavigation.bind(this));

        document.addEventListener('keydown', (e) => {
            if (e.keyCode === 27) {
                this.closeNavigation();
            }
		})

        this.RESIZE_NAV = debounce(() => {
            this.closeNavigation();
        }, 300);
        window.addEventListener('resize', this.RESIZE_NAV);

		this.submenuOnClick();
		
		if (this.SCROLL_LINKS.length) {
			for (let i = 0; i < this.SCROLL_LINKS.length; i++) {
				this.SCROLL_LINKS[i].addEventListener('click', this.closeNavigation.bind(this));
			}
		}

        /**
         * OPEN / TOGGLE MENU
         */

		this.NAV_TOGGLE.addEventListener('click', this.toggleNavigation.bind(this));

		/**
         * Handler for dark nav scroll
         */
		if (this.BREAKER) {
			this.darkNavScrollHandler();
			window.addEventListener('scroll', this.darkNavScrollHandler.bind(this));
		}

    }

	toggleNavigation() {

		// Check if toggleable 
		this.toggleable();

		// Toggle elements
		toggleClass(this.NAV_TOGGLE, 'open');
		toggleClass(this.NAV, 'open');
		toggleClass(this.NAV_OVERLAY, 'show');
		toggleClass(document.body, 'nav-open');
	}

	// Check if menu is toggleable
	toggleable() {
		if (!this.canToggle) return;
		this.canToggle = false;
		setTimeout(() => { this.canToggle = true; }, 200);
	}

	// Close the navigation
	closeNavigation() {
		removeClass(this.NAV_TOGGLE, 'open');
		removeClass(this.NAV, 'open');
		removeClass(this.NAV_OVERLAY, 'show');
        removeClass(document.body, 'nav-open');
	}

	// Append dropdown arrows for items with children
	appendDropdownArrows() {

		const MENUS_WITH_CHILDREN = document.querySelectorAll('.menu-item-has-children');

		for (let i = 0; i < MENUS_WITH_CHILDREN.length; i++) {

			const MENU_ITEM = MENUS_WITH_CHILDREN[i];
			const DROPDOWN_ELEMENT = document.createElement('div');

			DROPDOWN_ELEMENT.className = 'dropdown-arrow';
			DROPDOWN_ELEMENT.addEventListener('click', this.toggleSubMenu.bind(this));

			MENU_ITEM.appendChild(DROPDOWN_ELEMENT);
		}
	}

	// Close menu on submenu item click
	submenuOnClick() {

		const ALL_MENU_ITEMS = document.querySelectorAll('#menu-main-menu .current_page_item li');

		for (let i = 0; i < ALL_MENU_ITEMS.length; i++) {

			const MENU_ITEM = ALL_MENU_ITEMS[i];

			MENU_ITEM.addEventListener('click', () => {
				this.closeNavigation();
			});
		}
	}

	// Toggle submenu
	toggleSubMenu(e) {

		if (this.getScreenWidth() <= 1160) {

			const THIS = e.target;
			const MENU_WRAP = THIS.parentNode;
			const SUBMENU_WRAP = MENU_WRAP.querySelector('.sub-menu');
			const SUBMENU_ITEMS = SUBMENU_WRAP.querySelectorAll('.menu-item');
	
			toggleClass(MENU_WRAP, 'menu-open');
	
			if (hasClass(MENU_WRAP, 'menu-open')) {
				this.subMenuAnimation(SUBMENU_ITEMS);
			} else {
				this.hideSubMenuItems(SUBMENU_ITEMS);
			}
		}
	}

	subMenuAnimation(targetElements) {
		// animejs v3 ignored `elasticity` and fell back to its default easeOutElastic(1, .5)
		animate(targetElements, {
			translateX: ['-50px', 0],
			opacity: [0, 1],
			ease: 'outElastic(1, .5)',
			duration: 700,
			delay: stagger(75)
		});
	}

	hideSubMenuItems(targetElements) {
		for (let i = 0; i < targetElements.length; i++) {
			const SUBMENU_ITEM = targetElements[i];
			SUBMENU_ITEM.style.transform = 'translateX(-100%)';
		}
	}
    
    getScreenWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

    getScrollY() {
        return (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0);
    }

    getHeaderHeight() {
        return this.MAIN_HEADER.getBoundingClientRect().height;
	}

	darkNavScrollHandler() {
		const ADMIN_BAR = document.getElementById('wpadminbar');
		let top = this.BREAKER.getBoundingClientRect().top;
		let header_height = this.getHeaderHeight();
		header_height += ADMIN_BAR ? ADMIN_BAR.getBoundingClientRect().height : 0;

		if (top <= header_height) {
			document.body.classList.remove('dark-scroll-nav');
		} else {
			document.body.classList.add('dark-scroll-nav');
		}
	}
}